<ion-item class="ion-text-wrap">
    <ion-label>
        <p class="item-heading">{{ 'addon.mod_quiz.confirmstartheader' | translate }}</p>
        <p>{{ 'addon.mod_quiz.confirmstart' | translate:{$a: readableTimeLimit} }}</p>
    </ion-label>
</ion-item>
